import privacyMarkDown from './privacy.md';
import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';

function Privacy() {
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    fetch(privacyMarkDown)
      .then((res) => res.text())
      .then((text) => setMarkdown(text));
  }, []);

  return (
    <>
      <div className='content'>
        <h3>Privacy Policy</h3>
        <ReactMarkdown children={markdown} />
      </div>
    </>
  );
}

export default Privacy;

class PrivacyMD extends React.Component {
  constructor() {
    super();
    this.state = { markdown: '' };
  }

  componentWillMount() {
    // Get the contents from the Markdown file and put them in the React state, so we can reference it in render() below.
    fetch(privacyMarkDown)
      .then((res) => res.text())
      .then((text) => this.setState({ markdown: text }));
  }

  render() {
    const { markdown } = this.state;
    console.log(markdown);

    return <ReactMarkdown source={markdown} />;
  }
}
